import { Schema } from '../model/schema.model';
import { addDay } from '../utils/dateFormatter';

export function removeDay(schema, dayId) {
  if (!(schema instanceof Schema)) {
    throw new Error('Unsupported type');
  }

  schema.removeDay(dayId);

  let startDate = schema.days[0].date;

  schema.days.forEach(day => {
    day.date = Number(startDate);
    startDate = addDay(startDate);
  });

  return schema;
}
